<template>
  <div>
    <slot name="before-ui"></slot>
    <h3 class="flex-center width-expand text-center">
      {{ tt("payments.gateways.tranzilla.componentInnerTitle") }}
    </h3>
    <div class="flex flex-middle flex-center">
      <form-button
        v-if="!payment"
        :loading="isLoading"
        text="payments.gateways.tranzilla.initPaymentCta"
        @click="initiallize"></form-button>
    </div>
    <iframe
      v-if="isPaymentInitialized"
      :src="iframeUrl"
      style="width: 100%; height: 400px">
    </iframe>
    <slot name="after-ui"></slot>
  </div>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import paymentMixin from "@/client/extensions/mixins/paymentComponent.js";

export default {
  mixins: [paymentMixin],
  props: {},
  // this is inherited, but aparently you cant mixin emits?
  emits: [
    "payment:created",
    "payment:canceled",
    "payment:complete",
    "payment:completed",
    "payment:failed",
  ],
  setup(props) {
    let { asyncOps, asyncOpsReady } = asyncOperations(props);

    return { asyncOps, asyncOpsReady };
  },
  data() {
    return {
      isPaymentInitialized: false,
      payment: false,
      paymentId: false,
      isReady: false,
      gatewayConfig: false,
      languageMap: {
        he: "il",
        ar: "ar",
        en: "us",
        ru: "ru",
        es: "es",
        fr: "fr",
        jp: "jp",
      },
      currencyMap: {
        ILS: "1",
        USD: "2",
        EUR: "978",
      },
    };
  },
  computed: {
    successUrl() {
      if (!utilities.isSSR) {
        return "";
      }

      if (window.location.href.startsWith("http://localhost")) {
        return `http://localhost:3001/api/payment/confirmation-iframe/tranzilla/`;
      }
      let domain =
        window.location.protocol +
        "//" +
        window.location.hostname +
        (window.location.port ? ":" + window.location.port : "");
      return `${domain}/api/payment/confirmation-iframe/tranzilla/`;
    },
    iframeUrl() {
      let shortLanguageCode = this.sg("locale.slug")
        .substring(0, 2)
        .toLowerCase();
      let currencyCode = this.sg("currency.code");

      let url = `https://direct.tranzila.com/${this.gatewayConfig.terminalName}/iframenew.php?`;
      url = url + `sum=${this.amount / 100}&`;
      url = url + `currency=${this.currencyMap[currencyCode]}&`;
      url = url + `cred_type=${1}&`;

      url = url + `paymentId=${this?.payment?.id}&`;
      if (this?.payment?.uuid) {
        url = url + `paymentUuid=${this?.payment?.uuid}&`;
        url = url + `uuid=${this?.payment?.uuid}&`;
      }

      url = url + `amount=${this?.amount}&`;
      url = url + `lang=${this.languageMap[shortLanguageCode]}&`;

      return url;
    },
    readableAmount() {
      return this.translateNumber(this.amount, "currency", {
        to: this.currency,
      });
    },
  },
  mounted() {
    this.isLoading = true;
    this.getTranzillaConfig().then((conf) => {
      this.gatewayConfig = conf;
      this.isReady = true;
      this.isLoading = false;
    });
  },
  methods: {
    async getTranzillaConfig() {
      let url = "payment/tranzilla/config";
      let payload = {};

      let confResult = await this.asyncOps.asyncCall(url, payload, {
        method: "get",
      });

      if (confResult.hasError) {
        return false;
      }

      return {
        terminalName: confResult.data.terminalName,
        // "AcPVdfFsGvQnewZfihN5X80v6_ZqRHVBum8N0EmNAJSR2PEFeA-izwHf1Y9wC_Z3Ux7hBp0xrzc-26y5",
      };
    },
    async confirmPaymentByClient(paymentUuid, data) {
      if (!paymentUuid) {
        paymentUuid = this?.payment?.uuid;
      }
      let url = `payment/${paymentUuid}/tranzilla/clientConfirm`;

      let result = await this.asyncOps.asyncCall(url, data, {
        method: "patch",
      });

      return result;
    },
    async handleIframeMessage(data) {
      if (data.Response != "000" || !data.Tempref || data.Tempref === "") {
        this.emitFailedPayment({});
        this.setIsLoading(false);
        return false;
      }

      this.isLoading = true;
      let result = await this.confirmPaymentByClient(this?.payment?.uuid, data);
      this.isLoading = false;

      if (result.hasError) {
        this.emitFailedPayment({ error: "failed to confirm payment" });
        return;
      }

      this.emitSuccessfulPayment({});
    },

    async initiallize() {
      this.isLoading = true;

      let createResult = await this.createPayment(this.amount, this.currency);
      if (createResult.hasError) {
        this.emitFailedPayment({ error: "failed to create payment" });
        return false;
      }

      this.isLoading = false;

      this.payment = createResult.data.item;

      this.isPaymentInitialized = true;
    },
    async createPayment(amount = 5000, currency = "USD") {
      let url = "payment/";
      let user = this.sg("user.profile");
      let payload = {
        UserId: user?.id,
        amount: amount,
        currency: currency,
        handler: "tranzilla",
      };

      return await this.asyncOps.asyncCall(url, payload, { method: "post" });
    },
  },
};
</script>

<style scoped lang="scss"></style>
